module.exports = __webpack_public_path__ + "media/images/modular-kitchen-1-54475dfb1e10c848c3a49f85ec4ee570.jpg";